import StaticSelector from "components/Atoms/StaticSelector"
import StringInput from "components/Atoms/StringInput"
import ButtonMutation from "components/Molecules/ButtonMutation"
import { VEHICLE_STATUSES, VEHICLE_STATUSES_MAP } from "data/static.items"
import { BULK_UPDATE_VEHICLE_STATUS } from "graphql/vehicle/vehicle.mutations.gql"
import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { UPDATE_SELECTED_VEHICLE } from "store/all-vehicles/all-vehicles.actions"

function VehicleStatus({ vehicle }) {
  const [status, setStatus] = useState(vehicle?.status)
  const [remark, setRemark] = useState("")
  const dispatch = useDispatch()
  return (
    <div className="vt-status-update-form">
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-3">
          <StaticSelector
            value={status}
            onChange={(_, value) => setStatus(value)}
            label="Change Status"
            items={VEHICLE_STATUSES}
            helperText={
              <span className="text-muted">
                Current Status -{" "}
                <span className="vt-success">
                  {VEHICLE_STATUSES_MAP[vehicle?.status]?.name ?? "NA"}
                </span>
              </span>
            }
          />
        </div>
        <div className="col-span-9">
          <StringInput
            fill
            big={false}
            label="Remark"
            value={remark}
            onChange={(_, value) => setRemark(value)}
          />
        </div>
      </div>
      <div className="flex justify-end mb-5">
        <ButtonMutation
          icon="confirm"
          text="Update Status"
          mutation={BULK_UPDATE_VEHICLE_STATUS}
          onCompleted={({ bulkUpdateVehicleStatus: vs }) => {
            dispatch({
              type: UPDATE_SELECTED_VEHICLE,
              payload: vs?.vehicles?.[0],
            })
          }}
          variables={{
            status: status?.id,
            vehicles: [vehicle?.id],
          }}
        />
      </div>
    </div>
  )
}

export default VehicleStatus
